import { Box, Stack, Typography } from "@mui/material";
import React from "react";
 
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/manufacturing/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function TrainingSoftware() {
  const products = [
    "Enterprise Resource Planning (ERP) for Manufacturing",
   

  ];
  const data = {
    image: "/industries/manufacturing/erp.avif", // Replace with the appropriate image URL
    intro: `Optimize your manufacturing operations with our Enterprise Resource Planning (ERP) for Manufacturing. This solution integrates business processes, manages resources, and improves overall operational efficiency. Explore key features such as resource and capacity planning, inventory and order management, production scheduling and tracking, financial management and reporting, and integration with other manufacturing systems.`,
    keyFeatures: [
      {
        title: "Resource and capacity planning",
        content: "Efficiently plan and allocate resources to enhance overall manufacturing capacity.",
      },
      {
        title: "Inventory and order management",
        content: "Streamline inventory processes and manage orders effectively for improved efficiency.",
      },
      {
        title: "Production scheduling and tracking",
        content: "Optimize production schedules and track progress in real-time for better control.",
      },
      {
        title: "Financial management and reporting",
        content: "Gain real-time financial insights to support informed decision-making.",
      },
      {
        title: "Integration with other manufacturing systems",
        content: "Seamlessly integrate with MES, MOM, and quality management solutions for a comprehensive manufacturing ecosystem.",
      },
    ],
    howItWorks: `Learn how ERP for Manufacturing streamlines operations by providing a centralized platform for managing various aspects of the manufacturing process.`,
    benefits: {
      title: "The benefits of ERP for Manufacturing",
      data: [
        "Improved resource utilization and efficiency.",
        "Enhanced visibility into production processes.",
        "Streamlined order fulfillment and inventory control.",
        "Real-time financial insights for decision-making.",
      ],
    },
    industries: "Ideal for industries such as discrete manufacturing, process manufacturing, and mixed-mode manufacturing.",
    stories: `Explore success stories of organizations that have implemented ERP for Manufacturing, showcasing improvements in operational efficiency and business processes.`,
    contactUs: `Connect with our experts for inquiries and consultations related to the implementation of ERP for Manufacturing.`,
    technology: `Learn how ERP for Manufacturing seamlessly integrates with other manufacturing systems, including MES, MOM, and quality management solutions.`,
    support: `Access resources and support channels for users to understand and make the most of ERP for Manufacturing.`,
    industry: `Understand how ERP for Manufacturing adheres to industry standards and regulatory requirements for business process management.`,
    events: "Stay updated on relevant industry events and explore collaboration opportunities in ERP for Manufacturing technology research.",
    blog: `Read articles, case studies, and expert opinions in our ERP for Manufacturing blog and knowledge hub.`,
    careers: `Explore opportunities to contribute to the development and implementation of ERP for Manufacturing. Join us in shaping the future of integrated manufacturing systems.`,
  };
  
  
  const content = "Ignite innovation in manufacturing with us! Whether you're shaping advanced production technologies, supply chain optimization, or any aspect of the manufacturing sector, we offer customized solutions. Our expertise spans projects of various scales, ensuring our manufacturing solutions align seamlessly with your goals, budget, and scope."
    return (
    <>
  <Head>
    <title>Enterprise Resource Planning (ERP) for Manufacturing | Streamline Operations | Techbrain Networks</title>
    <meta name="description" content="Streamline your manufacturing operations with Techbrain Networks Enterprise Resource Planning (ERP) solutions. Enhance productivity and process management." />
    <meta name="keywords" content="ERP for manufacturing, enterprise resource planning, streamline operations, Techbrain Networks" />
    <meta property="og:title" content="Enterprise Resource Planning (ERP) for Manufacturing | Streamline Operations | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks Enterprise Resource Planning (ERP) solutions streamline manufacturing operations, enhancing productivity and process management." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/manufacturing/products/erp-for-manufacturing" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Enterprise Resource Planning (ERP) for Manufacturing" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Enterprise Resource Planning (ERP) for Manufacturing | Streamline Operations" />
    <meta name="twitter:description" content="Techbrain Networks ERP solutions streamline manufacturing operations, improving productivity and process management." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/manufacturing/products/erp-for-manufacturing" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Enterprise Resource Planning (ERP) for Manufacturing",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Techbrain Networks Enterprise Resource Planning (ERP) solutions streamline manufacturing operations, enhancing productivity and process management.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/manufacturing/products/erp-for-manufacturing",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
                   <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#0d57ba"} />

      <AppbarIndustry title={"Manufacturing"} homeLink={'/industries/manufacturing'} link={'/industries/manufacturing/products'} />
    <HeroSection img={'/industries/manufacturing/erp-for-manufacturing.avif'}>
    Enterprise Resource Planning (ERP) for Manufacturing



    </HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#010408",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#0d57ba"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#0d57ba"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#0d57ba",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#0d57ba"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#0d57ba"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
  {/* Industries */}
  <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#0d57ba"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

        

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#0d57ba"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
          Stay informed about upcoming features and innovations in battlefield simulation and training technology.


          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#0d57ba"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#0d57ba"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#010408",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#0d57ba"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#0d57ba",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
           <Box
            sx={{
              width: [ "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#0d57ba"} products={products} content={content}/>
          </Box>  
        </Box>
      </Box>
      <FooterIndustry ourProducts={ourProducts} color={"#0d57ba"} bg={"#010408"} />
    </>
  );
}

export default TrainingSoftware;
